import { render, staticRenderFns } from "./FormOthersFaixaContribuicao.vue?vue&type=template&id=3ec03e69"
import script from "./FormOthersFaixaContribuicao.vue?vue&type=script&lang=js"
export * from "./FormOthersFaixaContribuicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports